import type React from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useCurrentUser } from "../context/CurrentUserContext";
import FullPageLoader from "./FullPageLoader";

/**
 * Blocks members from accessing owner-only routes.
 * Redirects them to the Overview page instead.
 *
 * Owners and users with no role (during onboarding) pass through freely.
 */
const RoleGuard: React.FC<{ children: React.ReactNode, roles: string[] }> = ({ children, roles }) => {
	const { currentUser, isLoading } = useCurrentUser();
	const navigate = useNavigate();

	useEffect(() => {
		if (isLoading) return;
		if (currentUser?.role && !roles.includes(currentUser.role)) {
			navigate("/", { replace: true });
		}
	}, [currentUser, isLoading, navigate, roles]);

	if (isLoading) {
		return <FullPageLoader />;
	}

	if (currentUser?.role && !roles.includes(currentUser.role)) {
		return <FullPageLoader />;
	}

	return <>{children}</>;
};

export default RoleGuard;
